export * from './map';
export { DEFAULT_ICON_CONFIGS } from './runtime';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/index.js
// module id = null
// module chunks = 